import { Rule } from 'antd/es/form'
import { CSSProperties, FC } from 'react'
import { requiredOneElementRules } from '../../../constants/forms/validation/rules'
import { Select, Form } from 'antd'
import { useGetMaterialTypesQuery } from '../../../store/api/material-types-api'
import { QueryParams } from '../../../types/strapi/strapi'
import { SelectProps } from 'antd/lib'
import { NamePath } from 'antd/es/form/interface'
import { filterOptionByLabel } from '../../../helpers/filter-option-by-label'

interface MaterialTypesProps {
    noStyle?: boolean
    rules?: Rule[]
    mode?: SelectProps['mode']
    name?: NamePath
    onBlur?: () => void
    autoFocus?: boolean
    defaultOpen?: boolean
    disabled?: boolean
    dropdownStyle?: CSSProperties
    popupMatchSelectWidth?: SelectProps['popupMatchSelectWidth']
}

export const query: QueryParams = {
    fields: ['documentId', 'name'],
    pagination: { pageSize: 200, page: 1 },
}

const MaterialTypes: FC<MaterialTypesProps> = ({
    noStyle,
    mode,
    rules = requiredOneElementRules,
    name = 'materialTypes',
    onBlur,
    autoFocus,
    defaultOpen,
    disabled,
    dropdownStyle,
    popupMatchSelectWidth = 400,
}) => {
    
    const { data } = useGetMaterialTypesQuery(query)

    return (
        <Form.Item name={name} label={'Виды матерала'} rules={rules} noStyle={noStyle}>
            <Select
                style={{ width: '100%' }}
                options={data?.data.map(item => ({ value: item.documentId, label: item.name }))}
                mode={mode}
                showSearch
                filterOption={filterOptionByLabel}
                allowClear
                placeholder={'Материал'}
                popupMatchSelectWidth={popupMatchSelectWidth}
                dropdownStyle={dropdownStyle}
                onBlur={onBlur}
                autoFocus={autoFocus}
                defaultOpen={defaultOpen}
                disabled={disabled}
            />
        </Form.Item>
    )
}

export default MaterialTypes
